import { gql } from '@apollo/client';
import Attachments from './fragments/attachments.fragment';

export default gql`
  mutation updateAttachmentPath($input: UpdateAttachmentPathInput!) {
    updateAttachmentPath(input: $input) {
      ...LandingPageAttachments
    }
  }
  ${Attachments}
`;
